module.exports = __webpack_public_path__ + "img/step4-2.721da72e.png";